import { render, staticRenderFns } from "./AppClosedLayout.vue?vue&type=template&id=34d56f6a&scoped=true&"
import script from "./AppClosedLayout.vue?vue&type=script&lang=js&"
export * from "./AppClosedLayout.vue?vue&type=script&lang=js&"
import style0 from "./AppClosedLayout.vue?vue&type=style&index=0&id=34d56f6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d56f6a",
  null
  
)

export default component.exports